export const lightTheme = {
  colors: {
    primary: '#33A9FF',
    primaryDark: '#2196F3',
    primaryLight: '#E3F2FD',
    secondary: '#6C757D',
    success: '#C8F5D8',
    successText: '#4CAF50',
    warning: '#FFF4CC',
    warningText: '#FFA726',
    danger: '#FFE5E5',
    dangerText: '#F44336',
    info: '#E3F2FD',
    infoText: '#2196F3',
    background: '#F8F9FA',
    white: '#FFFFFF',
    black: '#000000',
    text: '#212529',
    textSecondary: '#6C757D',
    border: '#E0E0E0',
    gray: '#F5F5F5',
    card: '#FFFFFF',
  },
  fonts: {
    primary: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  fontSizes: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    round: '50%',
  },
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.1)',
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
  },
};

export const darkTheme = {
  colors: {
    primary: '#33A9FF',
    primaryDark: '#2196F3',
    primaryLight: '#1a3a52',
    secondary: '#9CA3AF',
    success: '#1a3d24',
    successText: '#4CAF50',
    warning: '#3d3520',
    warningText: '#FFA726',
    danger: '#3d1a1a',
    dangerText: '#F44336',
    info: '#1a2a3d',
    infoText: '#33A9FF',
    background: '#121212',
    white: '#1E1E1E',
    black: '#000000',
    text: '#E4E4E7',
    textSecondary: '#9CA3AF',
    border: '#2D2D2D',
    gray: '#2A2A2A',
    card: '#1E1E1E',
  },
  fonts: {
    primary: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  fontSizes: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    round: '50%',
  },
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.3)',
    md: '0 4px 6px rgba(0, 0, 0, 0.3)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.3)',
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
  },
};

// Mantener compatibilidad con código existente
export const theme = lightTheme;
